<template>
  <section>
    <section class="sales product-listing" v-if="categories.length > 0">
      <div v-for="items in allCategories">
        <div class="collection mb40" :id="'category_' + items.category.entity_id ">
          <div class="container px15 collection-header">
            <div class="row center-xs">
              <h3 class="align-left cl-accent custom-title col-xs-6 pr20 mt0">
                <router-link :to="categoryLink(items.category)" class="view-more-categ link">
                  {{ items.category.name }}
                </router-link>
              </h3>
              <h3 class="align-right cl-accent custom-total col-xs-6 px20 mt0">
                <router-link :to="categoryLink(items.category)" class="view-more" v-if="items.productsTotal > 0">
                  {{ items.productsTotal + ' ' +  $t('products') }}
                </router-link>
                <router-link :to="categoryLink(items.category)" class="view-more" v-else>
                  {{ '100+ ' + $t('products') }}
                </router-link>
              </h3>
            </div>
          </div>
          <div class="product-slider">
            <products-slider
              v-for="item in categories"
              v-if="items === item"
              :key="item.category.entity_id"
              :products="item.products"
              :config="sliderConfig"
              :title="item.category.name"
              :total="item.productsTotal"
              :category-ids="item.categoryIds"
              :category="item.category"
            />
          </div>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ProductsSlider from 'theme/components/core/ProductsSlider'
import Preloader from 'theme/components/theme/blocks/Home/Preloader'
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'

export default {
  name: 'CategorySliders',
  components: {
    ProductsSlider,
    Preloader
  },
  data () {
    return {
      slidersToLoad: 2,
      slidersListLoaded: false,
      sliderConfig: {
        'arrows': false,
        'infinite': false,
        'draggable': false,
        'cssEase': 'ease-out',
        'speed': 500,
        'slidesToShow': 6,
        'slidesToScroll': 6,
        'responsive': [
          {
            'breakpoint': 1024,
            'settings': {
              'slidesToShow': 4,
              'slidesToScroll': 4,
              'arrows': false
            }
          },
          {
            'breakpoint': 600,
            'settings': {
              'slidesToShow': 3,
              'slidesToScroll': 3,
              'arrows': false
            }
          },
          {
            'breakpoint': 480,
            'settings': {
              'slidesToShow': 2,
              'slidesToScroll': 2,
              'arrows': false
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('products_categories', {
      'getTotalSlidersAmount': 'getTotalSlidersAmount',
      'categories': 'getSlidersCategories',
      'currentSlidersAmount': 'getCategoriesLoaded',
      'allCategories' : 'categoriesProducts'
    }),
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    }),
    currentPartnerCode () {
      return this.currentPartner.code
    },
    currentLocationCode () {
      return this.$route.params.locationCode
    }
  },
  props: {
    currentId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    ...mapActions({
      loadProducts: 'products_categories/loadProducts',
      setSlidersAmount: 'products_categories/setCategoriesLoaded',
      cleanupSliderProducts: 'products_categories/cleanupSliderProducts'
    }),
    categoryLink (category) {
      return `/${this.currentLocationCode}/${this.currentPartnerCode}${formatCategoryLink(category)}`
    },

     loadMoreSliders () {
      if (this.getTotalSlidersAmount > this.currentSlidersAmount) {
        this.setSlidersAmount(this.currentSlidersAmount + this.slidersToLoad)
      }
    },
    loadNewProducts () {
      if ( this.categories ) {
        let number = this.categories.length - 2;
        if ( this.categories[number] ) {
          let el = document.getElementById('category_' + this.categories[number].category.entity_id);
          if ( el ) {
            if (window.scrollY >= el.offsetTop) {
              this.loadMoreSliders()
            }
          }
        }
      }
    }
  },
  mounted () {
    this.loadProducts({ id: this.currentId, store: this.currentPartnerCode, topCategory: this.$route.query.cat })
      .then(() => {
        this.slidersListLoaded = true
      })
    if ( this.categories ) {
      window.addEventListener('scroll', this.loadNewProducts)
    }
  },
  watch: {
    currentId (id) {
      this.cleanupSliderProducts()
      this.loadProducts({ id: id, store: this.currentPartnerCode, topCategory: this.$route.query.cat })
    },
    currentPartnerCode () {
      if (this.currentPartner && this.currentPartner.hasOwnProperty('root_category_id') && this.currentPartner.root_category_id) {
        this.cleanupSliderProducts()
        this.loadProducts({ id: this.currentPartner.root_category_id, store: this.currentPartnerCode, topCategory: this.$route.query.cat })
      }
    }
  }
}
</script>
<style lang="scss">
  .product-slider{
    height: 260px;
  }
  .sales.product-listing {
    padding-top: 0;
    padding-bottom: 24px;
    .VueCarousel-navigation button{
      z-index: 1;
    }
  }
  .half-circle-spinner, .half-circle-spinner * {
    box-sizing: border-box;
  }

  .half-circle-spinner {
    width: 60px;
    height: 60px;
    border-radius: 100%;
    position: relative;
    margin: 25px auto 0;
  }

  .half-circle-spinner .circle {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: calc(60px / 10) solid transparent;
  }

  .half-circle-spinner .circle.circle-1 {
    border-top-color: #349614;
    animation: half-circle-spinner-animation 1s infinite;
  }

  .half-circle-spinner .circle.circle-2 {
    border-bottom-color: #349614;
    animation: half-circle-spinner-animation 1s infinite alternate;
  }

  @keyframes half-circle-spinner-animation {
    0% {
      transform: rotate(0deg);

    }
    100%{
      transform: rotate(360deg);
    }
  }
  .perload-text{
    width: 100px;
    height: 22px;
    opacity: 0.6;
  }
  .perload-text-2 {
    width: 50px;
    height: 16px;
    background-color: #11bb2e;
    opacity: 0.6;
  }
</style>
<style scoped>
.link:hover {
  text-decoration: underline;
}
</style>
